import { render, staticRenderFns } from "./LegacyGenericWizard.vue?vue&type=template&id=35d89df4&"
import script from "./LegacyGenericWizard.vue?vue&type=script&lang=js&"
export * from "./LegacyGenericWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports